export enum EYandexApiUrl {
  nearestStationUrl = '/nearest_stations/',
  geocoderUrl = 'https://geocode-maps.yandex.ru/1.x',
}
